// src/services/lab/assistantService.js
//
// Le contexte de données est reconstruit côté serveur à partir du token : le
// client n'envoie que la question et l'historique. Il ne peut donc pas élargir
// son propre périmètre en trafiquant la requête.
import api from '../api';

const BASE = 'assistant/';

/** L'assistant est-il utilisable ? Renvoie aussi les suggestions du rôle. */
export const getEtatAssistant = async () => {
  const res = await api.get(`${BASE}etat/`);
  return res.data;
};

export const discuter = async (message, historique = []) => {
  const res = await api.post(`${BASE}discuter/`, { message, historique });
  return res.data;
};
